import ButtonTypes from './buttonTypes';

const EbayTasksStatus = {
  CREATED: 'CREATED',
  QUEUED: 'QUEUED',
  IN_PROCESS: 'IN_PROCESS',
  COMPLETED: 'COMPLETED',
  COMPLETED_WITH_ERROR: 'COMPLETED_WITH_ERROR',
  FAILED: 'FAILED',
  PARTIALLY_PROCESSED: 'PARTIALLY_PROCESSED',
};

export const EbayTasksStatusColor = {
  CREATED: ButtonTypes.LIGHT_DARK,
  QUEUED: ButtonTypes.WARNING,
  IN_PROCESS: ButtonTypes.INFO,
  COMPLETED: ButtonTypes.SUCCESS,
  COMPLETED_WITH_ERROR: ButtonTypes.DANGER,
  FAILED: ButtonTypes.DANGER,
  PARTIALLY_PROCESSED: ButtonTypes.DANGER,
};

export default EbayTasksStatus;
